import ApiUtil from '../util/ApiUtil';
import Constants from '../constants/Constants';
import {AxiosProgressEvent, AxiosRequestConfig, CancelTokenSource} from 'axios';

const baseUrl = '/api/v4/media';

const getAudioDescriptionDownloadUrl = (hash: string) => `${baseUrl}/${hash}/audiodescription`;

const removeAudioDescription = async (hash: string) => await ApiUtil.executeDeleteAsync(`${baseUrl}/${hash}/audiodescription`, [Constants.statusCodes.noContent]);

const uploadAudioDescription = async (hash: string, file: File, handleUploadProgress: (progressEvent: AxiosProgressEvent) => void, cancelTokenSource: CancelTokenSource) => {
   const postData = new FormData();
   postData.append('file', file);

   const requestConfig: AxiosRequestConfig = {headers: {'Content-Type': 'multipart/form-data'}, onUploadProgress: handleUploadProgress, cancelToken: cancelTokenSource.token};

   await ApiUtil.executePutAsync(`${baseUrl}/${hash}/audiodescription`, [Constants.statusCodes.created], postData, requestConfig);
};

export default {
   getAudioDescriptionDownloadUrl,
   removeAudioDescription,
   uploadAudioDescription
};
